/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Necessary_TitleInputs */

const da_consent_necessary_title = /** @type {(inputs: Consent_Necessary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nødvendige cookies`)
};

/** @type {(inputs: Consent_Necessary_TitleInputs) => LocalizedString} */
const en_consent_necessary_title = da_consent_necessary_title;

/**

* @param {Consent_Necessary_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_necessary_title = /** @type {((inputs?: Consent_Necessary_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Necessary_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_necessary_title(inputs)
	return /** @type {LocalizedString} */ ("Nødvendige cookies")
});